export enum OutboundSystemView {
  AWAITING_SHIPMENT = "awaiting-shipment",
  SHIPMENTS = "shipments",
  CREATE = "create",
}
